interface AppConfig {
  redirectUrl: string;
  oktaIssuer: string;
  oktaClientId: string;
  enableOktaAuth: boolean;
  model: string;
  baseURL: string;
  demoMode?: boolean;
  apiKey?: string;
}

let runtimeConfig: AppConfig | null = null;

async function loadConfig(): Promise<AppConfig> {
  try {
    const response = await fetch('/config.json', {
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    });

    if (response.ok) {
      const config = await response.json();
      console.log('[Config] Loaded from /config.json');
      runtimeConfig = config;
      return config;
    }
  } catch (error) {
    console.warn('[Config] Failed to load /config.json, using environment variables fallback', error);
  }

  const fallbackConfig: AppConfig = {
    redirectUrl: import.meta.env.VITE_REDIRECT_URL || 'http://localhost:5173',
    oktaIssuer: import.meta.env.VITE_OKTA_ISSUER || '',
    oktaClientId: import.meta.env.VITE_OKTA_CLIENT_ID || '',
    enableOktaAuth: import.meta.env.VITE_ENABLE_OKTA_AUTH === 'true',
    model: import.meta.env.VITE_DEFAULT_LLM_MODEL || 'Claude Haiku 4.5',
    baseURL: import.meta.env.VITE_BACKEND_BASE_URL 
      ? `${import.meta.env.VITE_BACKEND_BASE_URL}/v1` 
      : 'http://localhost:8000/v1',
    demoMode: import.meta.env.VITE_DEMO_MODE === 'true'
  };

  console.log('[Config] Using environment variables fallback');
  runtimeConfig = fallbackConfig;
  return fallbackConfig;
}

function getConfig(): AppConfig {
  if (!runtimeConfig) {
    throw new Error('Config not loaded. Call loadConfig() before accessing config.');
  }
  return runtimeConfig;
}

export { loadConfig, getConfig };
export type { AppConfig };

const config: AppConfig = new Proxy({} as AppConfig, {
  get(_target, prop: string) {
    if (!runtimeConfig) {
      throw new Error('Config not loaded. Call loadConfig() in main.tsx before rendering app.');
    }
    return runtimeConfig[prop as keyof AppConfig];
  }
});

export default config;
